import { createContext, useContext, useState, useEffect } from "react";
import {signInWithEmailAndPassword, onAuthStateChanged, signOut} from "firebase/auth"
import { auth } from "../firebase";

export const authContext = createContext()


export const useAuth =() =>{
    const context= useContext(authContext)
    if(!context) throw new Error('There is not auth provider')
    return context
}

export function AuthProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);

    const login=(email, password) => signInWithEmailAndPassword(auth, email, password);

    useEffect(() => {
        const unsubuscribe = onAuthStateChanged(auth, (currentUser) => {
          console.log({ currentUser });
          setUser(currentUser);
          setLoading(false);
        });
        return () => unsubuscribe();
      }, []);
    
    const logout = () => signOut(auth);

    return (
        <authContext.Provider value={{ user, login, logout, loading }}>
            {children}
        </authContext.Provider>
    )
}